'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createContext = require('./context/create-context.js');



exports.createSlotsContext = createContext.createSlotsContext;
//# sourceMappingURL=index.js.map
